import { ComponentRoute } from '@/classes'

const SuperadminFlexiquoteModuleRoutes = {
  FlexiquoteModuleView: new ComponentRoute('/superadmin/flexiquotemodule', 'FlexiquoteModuleView'),
  FlexiquoteModuleDetail: new ComponentRoute('/superadmin/flexiquotemodule', 'FlexiquoteModuleDetail'),
  FlexiquoteModuleListView: new ComponentRoute('/superadmin/flexiquotemodule/list', 'FlexiquoteModuleListView')
}

export default SuperadminFlexiquoteModuleRoutes

